// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';

const StyledButton = styled.button`
  && {
    border-radius: 1.3em;
    border: none;
    height: 2.5em;
    min-width: 6em;
    padding: 0 1em;
    font-family: BettingPoliticaExtraBold, sans-serif;
    font-weight: 800;
    cursor: pointer;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;

    font-size: ${Target.__MOBILE__ ? '1em' : '0.8em'};

    ${({ $isSelected, $isDark, theme }) => {
      const defaultStyle = css`
        border: solid 1px ${$isDark ? '#fff' : theme.grids.colors.grey};
      `;
      if ($isSelected) {
        return css`
          ${defaultStyle}
          color: ${$isDark ? theme.grids.colors.grey : '#fff'};
          background-color: ${$isDark ? '#fff' : theme.grids.colors.grey};
        `;
      }
      return css`
        ${defaultStyle}
        color: ${$isDark ? '#fff' : theme.grids.colors.grey};
        background-color: transparent;
      `;
    }}
  }
`;

const Center = styled.span`
  width: 100%;
  text-transform: uppercase;
`;

const Bullet = styled.span`
  display: inline-block;
  width: 0.4em;
  height: 0.4em;
  min-width: 0.4em;
  min-height: 0.4em;
  margin: 0 0 0 0.5em;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.grids.colors.redlight};
`;

type Props = {
  className?: string;
  children: Node;
  isSelected: boolean;
  isDark?: boolean;
  onClick: () => void;
  'data-testid'?: string; // to pass data-testid via styled-components :(
};

const TypeFilter = (props: Props) => {
  const { className, isDark, children, onClick, isSelected = false } = props;
  return (
    <StyledButton
      className={className}
      $isSelected={isSelected}
      onClick={onClick}
      $isDark={isDark}
      data-testid={props['data-testid']}
    >
      <Center>{children}</Center>
      {isSelected && <Bullet />}
    </StyledButton>
  );
};

export default TypeFilter;
